import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats numbers >= 1000 with a 'k' suffix (e.g., 1234 -> '1.2k')
 *
 * @export
 * @class CompactNumberPipe
 * @implements {PipeTransform}
 */
@Pipe({
    name: 'compactNumber',
    standalone: false
})
export class CompactNumberPipe implements PipeTransform {
  transform(value: number): string {
    const prefixes = ['', 'k', 'M'];

    let prefixIndex = 0;

    while (value >= 1000 && prefixIndex < prefixes.length - 1) {
      value /= 1000;
      prefixIndex++;
    }

    const fixedDigits = prefixIndex === 0 || value > 9 ? 0 : 1;

    return value.toFixed(fixedDigits) + prefixes[prefixIndex];
  }
}
